/** Bloque Dashlane, LastPass, 1Password, Bitwarden sur les champs non-mot de passe. */
export const INPUT_GUARD_PROPS = {
  autoComplete: 'off',
  'data-lpignore': 'true',
  'data-1p-ignore': true,
  'data-bwignore': 'true',
  'data-form-type': 'other',
  'data-dashlane-ignore': 'true',
};

export const DATE_PICKER_DEFAULT_PROPS = {
  valueFormat: 'DD/MM/YYYY',
  popoverProps: { withinPortal: true },
};

/** Listes déroulantes heure/minute (TimePicker intégré aux DateTimePicker). */
export const TIME_PICKER_DEFAULT_PROPS = {
  withDropdown: true,
  hoursStep: 1,
  minutesStep: 5,
  popoverProps: { withinPortal: true },
};
